// extracted by mini-css-extract-plugin
module.exports = {"GreenButton":"styles_GreenButton__3Rr2X","GreenButton--secondary":"styles_GreenButton--secondary__Akix4","GreenButton--fullWidth":"styles_GreenButton--fullWidth__33M1x"};